<template>
  <div class="about__footer">
    <div data-split>
      {{ globals.year }} © Francesco Prisco
      <br />
      VAT N. {{ globals.vat }}
      <br />
      {{ addText }}
    </div>
    <div class="about__footer__link">
      <AppLink class="fs-60 sp-12" :underline="true" @click="copyMail">
        {{ cta.text }}
      </AppLink>
    </div>
  </div>
</template>

<script setup>
const isMailConfirmVisible = useMailConfirmModal();
const globals = useGlobal();

const props = defineProps({
  cta: { type: Object, default: null },
  addText: { type: String, default: null },
});

const copyMail = () => {
  isMailConfirmVisible.value = true;
};
</script>

<style lang="scss" scoped>
.about__footer {
  align-items: flex-end;
  display: flex;
  line-height: 120%;
  position: relative;
  justify-content: space-between;
  margin-bottom: 6rem;

  @include mq(desktop) {
    align-items: flex-end;
    flex-direction: column;
    display: grid;
    margin-bottom: 0;
    gap: fluidMap($spacing, 16);
    grid-template-columns: 60% 40%;
  }
}
</style>
